import FieldType from '@/lib/constants/challengeModel/FieldType.enum';
import sortByPosition from '@/lib/utils/sorting/sortByPosition';
import useItemIsVisibleToPortfolioUser from '../useItemIsVisibleToPortfolioUser';
import { type Field } from '@/lib/types';
import { useContext } from 'react';
import PortfolioItemContext from '../../PortfolioItemContext';
import createdAtMatchesModelVisibilityDates from '../createdAtMatchesModelVisibilityDates';

const useSortedVisibleFields = (fields: Field[]): Field[] => {
  const { portfolioItem } = useContext(PortfolioItemContext);

  const itemIsVisibleToPortfolioUser = useItemIsVisibleToPortfolioUser();

  const hasValidFieldType = (field: Field): boolean => {
    return !!FieldType[field.type];
  };

  return fields
    .sort(sortByPosition)
    .filter(hasValidFieldType)
    .filter(field =>
      createdAtMatchesModelVisibilityDates(portfolioItem.createdAt, field),
    )
    .filter(itemIsVisibleToPortfolioUser);
};

export default useSortedVisibleFields;
